import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import {QuestionBase} from '../../../../core/components/dynamic-form/models/question-base';

export class FascicoloRecuperoCreditiStragiudiziale extends FascicoloFull {
  idREF: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }

  get form(): QuestionBase[] {
    return this.baseForm.concat([{
      key: 'idREF',
      label: 'Id REF',
      required: false,
      controlType: 'textbox',
      placeholder: 'Inserire Id REF',
      type: 'text',
      size: 'sm-6',
      value: this.idREF
    }] as QuestionBase[]);
  }
}
